import { APIResponseType } from "../../types/generics/APIResponse.type";
import { Talent, TalentEarnings, User } from "../../types/user";
import {
  createGetApiHook,
  createPatchApiHook,
  createPostApiHook,
  createPutApiHook,
  tokenSourceFn,
} from "./apiHooks";
import { API_BASE_URL } from "./axiosConfig";
import axios from "axios";

type talentQueryParams = Record<string, any>;

const getAllTalentAPI = (queryParams: talentQueryParams = {}): string => {
  const fullParams = {
    ...queryParams,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return `/talents?${queryString}`;
};

const postTalentProfileEndpoint = `/users/talents`;
const getAllTalentEndpoint = `/talents`;
const getTalentById = ({ id }: { id: number }) => `/talents/${id}`;
const updateTalentEndpoint = ({ id }: { id: number }) => `/users/talents/${id}`;
const updateProfileEndpoint = `/users/profile`;

export const useCreateTalentProfile = createPostApiHook<
  {},
  {},
  APIResponseType<User>
>(postTalentProfileEndpoint, {
  isFormDataMethod: false,
});

export const useUpdateProfile = createPutApiHook<{}, {}, APIResponseType<User>>(
  updateProfileEndpoint,
  {
    isFormDataMethod: false,
  }
);

export const useGetATalent = createGetApiHook<
  APIResponseType<Talent>,
  { id: number }
>(getTalentById);

export const useGetAllTalent = createGetApiHook<APIResponseType<Talent[]>, {}>(
  getAllTalentAPI
);

export const useUpdateTalent = createPutApiHook<
  {},
  { id: number },
  APIResponseType<Talent>
>(updateTalentEndpoint, {
  isFormDataMethod: false,
});

export const toggleCoffeeCallAvailabilityFn = async (
  talentId: string,
  data: Record<string, any>
) => {
  try {
    const response = await axios.patch(
      API_BASE_URL + `/users/talents/toggle-coffee-call`,
      { ...data },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "talent-id": talentId,
          Authorization: `Bearer ${tokenSourceFn()}`,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
